export enum ETipoCaracteristica
{
    Texto = 1,
    Numero = 2,
    Decimal = 3,
    ListaSimples = 4,
    ListaSubItens = 5,
    Cores = 6,
}
